module.exports = __webpack_public_path__ + "static/html-element_4-e6c07ccc7c0c8de1cb4ac7ca2a29163c.jpg";